import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNP = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M49.852 27.716ZM49.852 27.717 22.437.13a24.92 24.92 0 0 0-3.624.642C7.998 3.525 0 25 0 25S35 48.42 38.993 45.719a25.095 25.095 0 0 0 2.294-1.753L25.039 27.717h24.813Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M43.478 25 19.164.685C8.174 3.314 0 13.202 0 24.999c0 13.807 11.193 25 25 25a24.882 24.882 0 0 0 14.114-4.364L18.478 25h25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m23.777 36.913-3.053-1.436 1.625-2.957-3.315.634-.42-3.349-2.31 2.463-2.309-2.463-.42 3.35-3.315-.635 1.626 2.957-3.054 1.436 3.054 1.436-1.626 2.957 3.315-.634.42 3.35 2.31-2.464 2.309 2.463.42-3.349 3.315.634-1.626-2.957 3.054-1.436ZM21.74 13.866l-2.221-1.045 1.183-2.15-2.412.46-.305-2.435-1.68 1.791-1.68-1.791-.305 2.436-2.412-.461 1.183 2.15-2.22 1.045 5.434 1.087 5.435-1.087Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M22.826 13.865a6.522 6.522 0 0 1-13.043 0"
}));
FlagNP.displayName = 'FlagNP';
export default withFlagWrapper(FlagNP);
//# sourceMappingURL=index.js.map